import { Injectable } from '@angular/core';
import { ChangelogService } from 'app/core/services/changelog.service';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { Observable, ReplaySubject, map, switchMap, take, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
    private _notifications: ReplaySubject<Notification[]> = new ReplaySubject<
        Notification[]
    >(1);

    /**
     * Constructor
     */
    constructor(private _changelogService: ChangelogService) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for notifications
     */
    get notifications$(): Observable<Notification[]> {
        return this._notifications.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all notifications (las novedades de la plataforma, mapeadas al
     * shape que espera el componente de campanita del template)
     */
    getAll(): Observable<Notification[]> {
        return this._changelogService.get().pipe(
            map((response) =>
                (response.data?.entries ?? []).map(
                    (entry): Notification => ({
                        id: String(entry.id),
                        icon: 'heroicons_outline:sparkles',
                        title: entry.title,
                        description: `v${entry.version} — ${entry.changes.join(' · ')}`,
                        time: entry.publishedAt,
                        read: entry.read,
                    })
                )
            ),
            tap((notifications) => {
                this._notifications.next(notifications);
            })
        );
    }

    /**
     * Mark all notifications as read
     */
    markAllAsRead(): Observable<boolean> {
        return this.notifications$.pipe(
            take(1),
            switchMap((notifications) =>
                this._changelogService.markAllAsRead().pipe(
                    map((response) => {
                        // Go through all notifications and set them as read
                        notifications.forEach((notification, index) => {
                            notifications[index].read = true;
                        });

                        // Update the notifications
                        this._notifications.next(notifications);

                        // Return the updated status
                        return response.success;
                    })
                )
            )
        );
    }
}
